import React from 'react'
import { Spinner as ShadcnSpinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'

interface SpinnerProps {
  color?: string
  size?: string
  className?: string
}

export const Spinner: React.FC<SpinnerProps> = ({ size, className }) => (
  <ShadcnSpinner size={size === 'sm' ? 'sm' : 'md'} className={cn(className)} />
)
